import { constant, Decoder, number, object, string, union } from '@mojotech/json-type-validation'

import { User } from '@/domain/entities/user/user'
import { policyTypeDecoder } from '@/infrastructure/decoders/config/policyTypeDecoder'
import { displayLanguageTypeDecoder } from '@/infrastructure/decoders/language/displayLanguageTypeDecoder'
import { programLanguageTypeDecoder } from '@/infrastructure/decoders/language/programLanguageTypeDecoder'
import { submissionsStatusDecoder } from '@/infrastructure/decoders/submission/submissionStatusDecoder'

export const userDecoder: Decoder<User> = object({
  id: string(),
  name: string(),
  avatar: union(string(), constant(null)),
  policy: policyTypeDecoder,
  country: string(),
  defaultProgrammingLanguage: programLanguageTypeDecoder,
  displayLanguage: displayLanguageTypeDecoder,
  status: union(submissionsStatusDecoder, constant(null)),
  registerDate: number().map(x => new Date(x)),
  affiliation: union(string(), constant(null)),
  birthYear: union(number(), constant(null)),
  lastSubmitDate: union(
    number().map(x => new Date(x)),
    constant(null)
  ),
  url: union(string(), constant(null))
}).map(x => ({ ...x, programLanguage: x.defaultProgrammingLanguage }))
